<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" max-width="500">
      <template v-slot:activator="{ on }">
        <v-btn small flat color="success" dark v-on="on" @click="time">Deposer</v-btn>
      </template>
      <Burkina :amount ="montant"/>
      <Civ :amount ="montant"/>
      <MALI :amount ="montant"/>
      <Senegal :amount ="montant"/>
      <BENIN :amount ="montant"/>
      <GABON :amount ="montant"/>
      <CAMEROUN :amount ="montant"/>
      <PAYGATE :amount ="montant" :moyen = "moyen"/>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Depot Cfa</v-card-title>
        <v-card-text>
          <v-window v-model="step">
            <v-window-item :value="1">
              <v-form>
                <v-text-field solo type="number" label="Montant" v-model="montant" class="first"></v-text-field>
                <v-layout row wrap justify-space-between>
                  <v-flex xs7>
                    <v-select
                      :items="countries"
                      v-model="country"
                      label="Votre PAYS"
                      @change="handlePay"
                    ></v-select>
                  </v-flex>
                  <v-flex xs5 v-if="!fedapay && !methods_less">
                    <v-select
                      :items="moyens"
                      v-model="moyen"
                      label="Moyen de paiement"
                      @change="num"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-window-item>
            <v-window-item :value="2">
              <v-flex xs12 text-xs-center>
                <p
                  class="green--text body-2 font-weight-bold"
                >Finalisez votre dépot en suivant les instructions suivantes</p>
                <div v-if="flooztg" class="red--text body-2 font-weight-bold">
                  
                  <v-alert
                    v-model="flooztg"
                    
                    color="error"
                  >
                  <span class="mb-3 font-weight-bold" style="ponter:cursor;">PAIEMENT MARCHAND<br/></span>
                  Ce numero est un numero marchand
                  la synthaxe pour le paiement est: <span class="font-weight-bold" style="font-size: 2em;">*155*2*2*{{numero}}*{{numero}}*{{montant}}#</span><br>
                  si vous faites un envoi classique ou normal sur ce numero, l'operation va echouer
                  
                  </v-alert>
                </div>
                <!-- <p class="caption red--text" v-if="moyen=='Flooz'">Veillez choisir Transfert MARCHANT dans les options d'envoi flooz</p> -->
              </v-flex>
              <br />
              <v-layout row wrap>
                <v-flex>
                  <table class="pure-table" style="margin:0 auto; ">
                    <tbody>
                      <tr>
                        <td>Montant</td>
                        <td
                          class="font-weight-bold"
                        >{{new Intl.NumberFormat("fr-FR", {maximumFractionDigits:1}).format(montant)}} cfa</td>
                      </tr>
                      <tr>
                        <td>Moyen</td>
                        <td>{{moyen}}</td>
                      </tr>
                      <tr>
                        <td>Numero</td>
                        <td>{{numero}}</td>
                      </tr>

                      <tr>
                        <td>Nom</td>
                        <td>{{nom}}</td>
                      </tr>
                      <tr v-if="cond && moyen !== 'Ecobank'">
                        <td>Prenoms</td>
                        <td>{{firstName}}</td>
                      </tr>
                      <tr v-if="showCountry">
                        <td>PAYS</td>
                        <td>{{sendCountry}}</td>
                      </tr>
                      <tr v-if="showTown">
                        <td>Ville</td>
                        <td style="color:red;">{{town}}</td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
                <v-flex v-if="moyen=='MTN-BENIN'">
                  <div style="margin:0 auto; ">
                    <p class="red--text caption">Paiement MOMOPAY</p>
                    <ul style="font-size:0.9em;">
                      <li>Tapez *840#</li>
                      <li>2</li>
                      <li>1</li>
                      <li>entrez le numero marchand</li>
                      <span class="font-weight-bold">51 40 31 80 (D-OFFICE)</span>
                      <li>entrez le numero marchand</li>
                      <span class="font-weight-bold">51 40 31 80 (D-OFFICE)</span>
                      <li>montant</li>
                      <li>1</li>
                      <li>confirmez avec le code PIN</li>
                    </ul>
                  </div>
                </v-flex>
              </v-layout>

              <br />
              <p class="caption green--text">Après l'envoi entrez l'ID ou code d'envoi et deposez</p>
              <v-form @submit.prevent="deposer" ref="form">
                <v-text-field
                  type="number"
                  label="ID Transaction ou numero Ecobank ou code Wari"
                  :rules="codeRules"
                  v-model="code"
                ></v-text-field>
                <v-flex xs12 text-xs-center>
                  <v-btn color="success" type="submit">deposer</v-btn>
                </v-flex>
              </v-form>
            </v-window-item>
          </v-window>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn :disabled="step === 1" flat @click="back">Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="paygate"
            :disabled="step === 2"
            color="success"
            depressed
            @click="paygatePayment"
          >Automatique {{moyen=="Flooz" ? paygateFloozFee : paygateTmoneyFee}}</v-btn>
          <v-spacer></v-spacer>


          <v-btn
            v-if="moyen =='Flooz' && !isNight 
            //|| moyen =='Tmoney' && !isNight 
            || moyen =='MTN-BENIN' 
            "
            class="mx-2"
            :disabled="step === 2"
            color="success"
            depressed
            @click="incrementStep"
          >Manuel</v-btn>
          <v-btn
            v-if="suivant"
            :disabled="step === 2"
            color="success"
            depressed
            @click="incrementStep"
          >suivant</v-btn>
           <!-- <v-btn color="primary" v-if="fedapay" @click="fedapay_payment">Depot automatique</v-btn> -->
           <v-btn color="primary" v-if="country=='MALI'" @click="intouch_mali">Depot automatique</v-btn>
           <v-btn color="primary" v-if="country=='SENEGAL'" @click="intouch_senegal">Depot automatique</v-btn>
           <v-btn color="primary" v-if="country==`COTE D'IVOIRE` " @click="intouch_civ">Depot automatique</v-btn>
           <v-btn color="primary" v-if="country=='BURKINA-FASO'" @click="intouch_bf">Depot automatique</v-btn>
           <v-btn color="primary" v-if="country=='GABON'" @click="intouch_gabon">Depot automatique</v-btn>
           <v-btn color="primary" v-if="country=='CAMEROUN'" @click="intouch_cm">Depot automatique</v-btn>
           <v-btn color="primary" v-if="country=='BENIN'" @click="qosic_benin">Depot automatique</v-btn>
          <v-btn color="primary" v-if="kkiapay || country=='VISA/MASTERCARD'" >Depot automatique</v-btn>
          <v-btn flat :hidden="step === 1" color="success" depressed @click="dialog = false">fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



  </div>
</template>
<script>
import firebase from '../../fb'
import { mapGetters, mapActions } from 'vuex'
import Burkina from '../intouch/burkina.vue'
import Civ from '../intouch/civ.vue'
import MALI from '../intouch/mali.vue'
import Senegal from '../intouch/senegal.vue'
import GABON from '../intouch/gabon.vue'
import CAMEROUN from '../intouch/cameroun.vue'

import BENIN from '../qosic/benin.vue'
import PAYGATE from '../paygate/paiement.vue'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
export default {
  components: {
    Burkina,
    Civ,
    MALI,
    Senegal,
    GABON,
    CAMEROUN,
    BENIN,
    PAYGATE

  },
  data() {
    return {
      paygateFee:0.00,
      paygateFloozFee: ' 2%',
      paygateTmoneyFee:' 2%',
      flooztgPaygateFee:null,
      valid_om_mali: false,
      suivant:false,
      paygate_token: process.env.VUE_APP_PAYGATE_TOKEN,
      fedapay_secret:process.env.VUE_APP_FEDAYPAY_SECRETE,
      kkiapay_key:process.env.VUE_APP_KKIAPAY_KEY,
      dialog: false,
      isNight:false,
      fedapay:false,
      kkiapay:false,
      moyens: [],
      countries: ["TOGO", "BENIN", "COTE D'IVOIRE","SENEGAL", "MALI", "BURKINA-FASO", "AUTRE PAYS"],
      flooztg: false,
      step: 1,
      country: "",
      sendCountry: "",
      moyen: "",
      montant: "",
      town: "",
      nom: "",
      numero: "",
      firstName: "",
      cond: false,
      showCountry: false,
      showTown: false,
      code: "",
      cardNumber: null,
      options: {
        creditCard: true,
        delimiter: "-"
      },
      Flooz: {
        number: "96780563",
        name: "HIROPAY"
      },
      Tmoney: {
        number: "92 25 92 67",
        name: "HIROPAY"
      },
      Ecobank: {
        number: 141126204001,
        name: "HIROPAY",
        firstName: ""
      },
      Wari: {
        number: "+22892259267",
        name: "KATAKA",
        firstName: "koffi dessirama"
      },
      MTNBENIN: {
        number: "51 40 31 80",
        name: "D-OFFICE"
      },
      RIA: {
        number: "+22892259267",
        name: "KATAKA",
        sendCountry: "TOGO",
        firstName: "koffi dessirama"
      },
      Western: {
        number: "+22892259267",
        name: "KATAKA",
        sendCountry: "TOGO",
        firstName: "koffi dessirama"
      },
      izza: {
        number: "+22892259267",
        name: "HIROPAY",
        sendCountry: "TOGO",
        firstName: "HIROPAY",
        town: "Demandez au support (+22892259267)"
      },
      bnif: {
        number: "+22892259267",
        name: "KATAKA",
        sendCountry: "TOGO",
        firstName: "koffi dessirama",
        town: "Demandez au support (+22892259267)"
      },
      codeRules: [
        v => !!v || "obligatoire",
        v => /^[0-9]{8,15}$/.test(v) || "invalide"
      ]
    };
  },
  computed: {
    paygate() {
      let tg_momo = ['Flooz', 'Tmoney']
       return tg_momo.indexOf(this.moyen) >= 0 &&this.country == 'TOGO'
    },

    
    instant_data() {
      let obj = {}
      this.instant.forEach(element => {
        obj[`${element.id}`] = element
      });
      return obj
    },

    methods_less(){
      let items =[`COTE D'IVOIRE`,'SENEGAL','MALI','BURKINA-FASO', 'VISA/MASTERCARD', 'BENIN', 'GABON', 'CAMEROUN', 'KENYA' ]
      return items.indexOf(this.country) >= 0
    },
    ...mapGetters({
      instant: "authfb/instant"
    }),

  },


  watch: {
    country(newValue, oldValue) {
      newValue != "SENEGAL"? this.fedapay = false : this.fedapay = true
      newValue == "NIGER" || newValue == "AUTRE PAYS" ? this.suivant = true : this.suivant = false
      newValue != "BENIN"? this.kkiapay = false :''
      
    },

    moyen(newValue, oldValue) {
      newValue == "MTN/MOOV automatique"? this.kkiapay = true : this.kkiapay = false
      newValue == 'Ecobank'  ? this.suivant = true : ""
      newValue == 'FLOOZ'  ? this.suivant = true : ""
    }
  },

  mounted () {
    this.bind_instant();
  },

  methods: {
    intouch_bf(){
      this.$root.$emit('intouch_bf',true)
    },
    intouch_civ(){
      this.$root.$emit('intouch_civ',true)
    },

    intouch_mali(){
      console.log('hii');
      this.$root.$emit('intouch_mali',true)
    },

    intouch_senegal(){
      
      this.$root.$emit('intouch_senegal',true)
    },

    intouch_gabon(){
      
      this.$root.$emit('intouch_gabon',true)
    },

    intouch_cm(){
      
      this.$root.$emit('intouch_cm',true)
    },



    qosic_benin(){
      console.log('hi');
      this.$root.$emit('qosic_benin',true)
    },
    

  time(){
      let hours = new Date().getHours()
      console.log(hours);
      let isNightTime = hours < 7 || hours >= 22
      this.isNight =isNightTime
    



      let user = this.$store.getters['authfb/user']
      console.log(user);

      if (!user) {
        swal("Erreur survenu!", "contactez le support et fournissez votre email pour assistance avant d'effecturer le dépot!", "error", {
            button: "ok"
          })

          setTimeout(() => {
            this.dialog = false
            
          }, 2000);
        
      }
   },

    incrementStep() {
      if (this.montant > 0) {
        if (
          this.moyen == "Wari" ||
          this.moyen == "Western Union" ||
          this.moyen == "RIA" ||
          this.moyen == "BNIF AFUWA" ||
          this.moyen == "AL IZZA"
        ) {
          if (this.montant < 50000) {
            swal(
              "Montant minimum 50000 cfa",
              "veillez changer le montant ou moyen de paiement",
              "error",
              {
                button: "ok"
              }
            );
          } else {
            this.step++;
          }
        } else {

          if (this.moyen == 'Tmoney' && this.montant < 25000) {
            swal(
              "Montant minimum 25000 cfa",
              "veillez changer le montant ou moyen de paiement",
              "error",
              {
                button: "ok"
              }
            );

            return
          }



          if (this.montant < 10000) {
            swal(
              "Montant minimum 10000 cfa",
              "veillez changer le montant ou moyen de paiement",
              "error",
              {
                button: "ok"
              }
            );
          } else {
            this.step++;
          }

        }
      }
    },

    back() {
      this.step--;
      this.numero = "";
      this.moyens = [];
      this.moyen = "";
      this.country = "";
      this.flooztg = false;
      this.showTown = false;
      this.showCountry = false;
      this.nom = "";
      this.fedapay = false
    },
    async paygatePayment() {
      if (this.montant>=500) {
         this.$root.$emit('paygate_paiement',true)
      }else{
        swal(
              "Montant minimum  500  cfa",
              "veillez changer le montant",
              "error",
              {
                button: "ok"
              }
            );
      }
    },
    num() {
      if (this.country == "TOGO" && this.moyen == "Flooz") {
        let mix = this.Flooz;
        this.numero = mix.number;
        this.nom = mix.name;
        this.firstName = mix.firstName;
        this.cond = false;
        this.flooztg = true;
      } else if (this.moyen == "FLOOZ") {
        let mix = this.FLOOZ;
        this.numero = mix.number;
        this.nom = mix.name;
        this.firstName = mix.firstName;
        this.cond = false;
      } else if (this.moyen == "Tmoney") {
        let mix = this.Tmoney;
        this.numero = mix.number;
        this.nom = mix.name;
        this.firstName = mix.firstName;
        this.flooztg = false;
        this.cond = false;
      } else if (this.moyen == "Ecobank") {
        let mix = this.Ecobank;
        this.numero = mix.number;
        this.nom = mix.name;
        this.firstName = mix.firstName;
        this.cond = true;
      } else if (this.moyen == "Wari") {
        let mix = this.Wari;
        this.numero = mix.number;
        this.nom = mix.name;
        this.firstName = mix.firstName;
        this.cond = true;
      } else if (this.moyen == "RIA") {
        let mix = this.RIA;
        this.numero = mix.number;
        this.nom = mix.name;
        this.firstName = mix.firstName;
        this.sendCountry = mix.sendCountry;
        this.cond = true;
        this.showCountry = true;
      } else if (this.moyen == "Western Union") {
        let mix = this.Western;
        this.numero = mix.number;
        this.nom = mix.name;
        this.sendCountry = mix.sendCountry;
        this.firstName = mix.firstName;
        this.cond = true;
        this.showCountry = true;
      } else if (this.moyen == "AL IZZA") {
        let mix = this.izza;
        this.numero = mix.number;
        this.nom = mix.name;
        this.sendCountry = mix.sendCountry;
        this.firstName = mix.firstName;
        this.cond = false;
        this.showCountry = false;
        this.showTown = true;
        this.town = mix.town;
      } else if (this.moyen == "BNIF AFUWA") {
        let mix = this.bnif;
        this.numero = mix.number;
        this.nom = mix.name;
        this.sendCountry = mix.sendCountry;
        this.firstName = mix.firstName;
        this.cond = true;
        this.showCountry = false;
        this.showTown = true;
        this.town = mix.town;
      } else if (this.moyen == "MTN-BENIN") {
        let mix = this.MTNBENIN;
        this.numero = mix.number;
        this.nom = mix.name;
        this.cond = false;
      }
    },
    handlePay() {
      const  isWeekend = () => {
        const date = new Date();
        console.log(date);
        const day = date.getDay();
        return day === 6 || day === 0;
      }
      
      if (this.country == "TOGO") {
        isWeekend()? this.moyens = ["Flooz","Tmoney"] :this.moyens = ["Flooz","Tmoney", "Ecobank"]
        
      } else if (this.country == "AUTRE PAYS") {
        this.moyens = [ "Ecobank"]
        
      }
      
    },
    deposer() {
      if (
        this.montant &&
        this.moyen &&
        this.code &&
        this.$refs.form.validate()
      ) {
        this.$store
          .dispatch("deposit/depotCfa", {
            type: "cfa",
            amount: Number(this.montant),
            moyen: this.moyen,
            txid: Number(this.code)
          })
          .then(() => {
            this.code = 0;
            this.moyen = "";
            this.numero = "";
            this.firstName = "";
            this.lastName = "";
            this.country = "";
            this.dialog = false;
            this.step--;
            this.montant = "";
          });
      }
    },
    ...mapActions('authfb', ['bind_instant']),
  }
};
</script>

<style scoped>
td.md-table-cell {
  font-size: 1.2em;
}
.first {
  max-width: 200px !important;
  display: block;
  margin: auto;
}
div.v-input.first {
  font-size: 2em !important;
  align-content: center;
}
</style>

<style >
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
